import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import FinalSiwesApplicationsPage from "../components/applications/finalsiwes";
import "../additionalcss/style.css";

function FinalSiwesApplications() {
  const location = useLocation();

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    window.scroll({ top: 0 });
    document.querySelector("html").style.scrollBehavior = "";
  }, [location.pathname]);
  return (
    <>
      <FinalSiwesApplicationsPage />
    </>
  );
}

export default FinalSiwesApplications;
